export default __webpack_public_path__ + "static/michalSlawinski-40b2755a553c220a28e1a68f328c54da.png";